import React from 'react';
import { History as LucideHistory } from 'lucide-react';

interface HistoryProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const History: React.FC<HistoryProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideHistory width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default History;
